// loader.service.ts
import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  // Comptador de peticions en marxa
  private _pendingRequests = signal(0);

  readonly isLoading = computed(() => this._pendingRequests() > 0);

  show(): void {
    this._pendingRequests.update((v) => v + 1);
  }

  hide(): void {
    this._pendingRequests.update((v) => Math.max(0, v - 1));
  }

  // Per si vols forçar-ho
  reset(): void {
    this._pendingRequests.set(0);
  }
}
